import RsaGestioneCamereListPage from "./pages/RsaGestioneCamereListPage.vue";
import RsaGestioneCamereViewPage from "./pages/RsaGestioneCamereViewPage.vue";
import RsaGestioneCameraStoricoViewPage from "./pages/RsaGestioneCameraStoricoViewPage.vue";

export default {
    RsaGestioneCameraStoricoViewPage,
    RsaGestioneCamereListPage,
    RsaGestioneCamereViewPage,
};
